"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _summaryCard = require("./summaryCard.tokens");
var _globalTokens = require("../../../shared/global-tokens");
var _FlexColumn = require("../../layout/flex/FlexColumn");
var _FlexRow = require("../../layout/flex/FlexRow");
var _Subheading = _interopRequireDefault(require("../../text/Subheading"));
var _Text = _interopRequireDefault(require("../../text/Text"));
var _IconTooltip = _interopRequireDefault(require("../../feedback/tooltip/IconTooltip"));
var _jsxRuntime = require("react/jsx-runtime");
var SummaryCardContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "SummaryCard__SummaryCardContainerWrapper",
  componentId: "sc-1ywnxhv-0"
})(["display:flex;flex-direction:row;flex-wrap:", ";width:100%;gap:", ";"], function (_ref) {
  var wrap = _ref.wrap;
  return wrap ? 'wrap' : 'nowrap';
}, _globalTokens.globalSpacing[600]);
var SummaryCardWrapper = _styledComponents.default.div.withConfig({
  displayName: "SummaryCard__SummaryCardWrapper",
  componentId: "sc-1ywnxhv-1"
})(["display:flex;flex-direction:row;flex-grow:", ";", ";border-radius:", ";flex-basis:", ";padding:", ";"], function (_ref2) {
  var flexGrow = _ref2.flexGrow;
  return flexGrow ? flexGrow : '1';
}, _summaryCard.tokens.border.default, _globalTokens.globalBorder.radius['2'], function (_ref3) {
  var flexBasis = _ref3.flexBasis;
  return flexBasis ? flexBasis : '200px';
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding ? padding : _globalTokens.globalSpacing[400];
});
var Container = function Container(_ref5) {
  var wrap = _ref5.wrap,
    children = _ref5.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SummaryCardContainerWrapper, {
    wrap: wrap,
    children: children
  });
};
exports.Container = Container;
var SummaryCard = function SummaryCard(_ref6) {
  var title = _ref6.title,
    titleTooltip = _ref6.titleTooltip,
    subtitle = _ref6.subtitle,
    flexBasis = _ref6.flexBasis,
    flexGrow = _ref6.flexGrow,
    children = _ref6.children;
  var theChildren = children;
  if (children && !children.map) {
    theChildren = [children];
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SummaryCardWrapper, {
    flexBasis: flexBasis,
    flexGrow: flexGrow,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexColumn.FlexColumn, {
      gap: 'l',
      children: [title || subtitle ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexColumn.FlexColumn, {
        flex: '0 1 auto',
        children: [title !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Subheading.default, {
            size: '1',
            children: title || ' '
          }), titleTooltip !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconTooltip.default, {
            size: 'l',
            children: titleTooltip
          }) : null]
        }) : null, subtitle !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          size: '2',
          children: subtitle || ' '
        }) : null]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), theChildren && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexColumn.FlexColumn, {
        flex: '0 1 auto',
        children: theChildren.map(function (child) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexRow.FlexRow, {
            children: child
          });
        })
      })]
    })
  });
};
SummaryCard.Container = Container;
SummaryCard.defaultProps = {
  flexBasis: '200px',
  flexGrow: '1'
};
Container.defaultProps = {
  wrap: true
};

// ONLY USED FOR STORYBOOK DOCUMENTATION
var _default = exports.default = SummaryCard;